import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth, ACCOUNT_LOADING, createContactRequest } from "../firebase/firebase";
import styles from './contact-page-style.module.css'

function ContactPage({setShowNavBar}) {

    const [account, accountData] = useAuth();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const contactType = searchParams.get('type');
    var initialCategory = '';
    var initialMessage = '';

    if (contactType === '404') {
        initialCategory = '404-error';
        initialMessage = `Experienced a 404 error\nAttempted Path: '${searchParams.get('path')}'`;
    } else if (contactType === 'pd') {
        initialCategory = 'account-permissions';
        initialMessage = `Experienced a permission denied\nAttempted Path: '${searchParams.get('path')}'\nAccount ID: '${searchParams.get('accountId')}'\n\nGIVE ME MORE POWER!!!!! (please)`;
    }

    var initialName = (accountData != null && accountData !== ACCOUNT_LOADING) ? `${accountData?.first_name} ${accountData?.last_name}` : '';

    const [name, setName] = useState(initialName);
    const [email, setEmail] = useState(accountData?.email);
    const [phoneNumber, setPhoneNumber] = useState(accountData?.phone_number);
    const [category, setCategory] = useState(initialCategory);
    const [message, setMessage] = useState(initialMessage);

    useEffect(() => {
        if (accountData != null && accountData !== ACCOUNT_LOADING) {
            setShowNavBar(true);
            setName(`${accountData.first_name} ${accountData.last_name}`);
            setEmail(accountData.email);
            setPhoneNumber(accountData.phone_number);
        } else
            setShowNavBar(false);
    }, [account, accountData, setShowNavBar]);

    const handleSubmit = () => {
        var id = '';

        if (name === '' || name === undefined) {
            id = 'name';
        } else if (email === '' || email === undefined) {
            id = 'email';
        } else if (phoneNumber === '' || phoneNumber === undefined) {
            id = 'tel';
        } else if (category === ''|| category === undefined) {
            id = 'category';
        } else if (message === '' || message === undefined) {
            id = 'message';
        }

        if(id !== '')
            document.getElementById(id).classList.add(styles.empty_field);
        else
            createContactRequest({name, email, phoneNumber, category, message, status: 'submitted'}).then(() => {
                    document.getElementById('name').value = '';
                    document.getElementById('email').value = '';
                    document.getElementById('tel').value = '';
                    document.getElementById('category').value = '';
                    document.getElementById('message').value = '';

                    document.getElementById(styles.submitted).style.display = 'block';
                    
                    setName('');
                    setEmail('');
                    setPhoneNumber('');
                    setCategory('');
                    setMessage('');

                    navigate('/contact#submitted')
                })
    };

    const phoneKeydownListener = (evt) => {
        if (!(evt.ctrlKey || evt.key.length > 1 || /[0-9.]/.test(evt.key)))
            evt.preventDefault();
    }

    const phoneKeyUpListener = (evt) => {
        const digits = evt.target.value.replace(/\D/g,'').substring(0,10);
        const areaCode = digits.substring(0,3);
        const prefix = digits.substring(3,6);
        const suffix = digits.substring(6,10);

        if(digits.length > 6) {evt.target.value = `(${areaCode}) ${prefix}-${suffix}`;}
        else if(digits.length > 3) {evt.target.value = `(${areaCode}) ${prefix}`;}
        else if(digits.length > 0) {evt.target.value = `(${areaCode}`;}
    }
    
    return (
        <div id={styles.contact_page}>
            <h1>Contact Us</h1>
            <div id={styles.container}>
                <div id={styles.contact_info}>
                    <p>To contact us, you can fill out the contact form or email/call us.</p>
                    <p>For technical questions about this website, please contact:
                        <br/>Whitaker Kohls
                        <br/><a href='mailto:whitaker@thecampbytheriver.com'>whitaker@thecampbytheriver.com</a>
                        <br/><a href='tel:937-746-3811'>(937) 746-3811</a> extension 703</p>
                    <p>For questions about Camp Chautauqua, please contact our office staff:
                        <br/><a href='mailto:info@thecampbytheriver.com'>info@thecampbytheriver.com</a>
                        <br/><a href='tel:937-746-3811'>(937) 746-3811</a></p>
                </div>
                <div id={styles.contact_form}>
                        <h1>Contact Form</h1>
                        <label htmlFor="name" >Name<span style={{color: 'red'}}>*</span></label>
                        <input id='name' defaultValue={initialName} onChange={(e) => {setName(e.target.value); e.target.classList.remove(styles.empty_field);}}/>

                        <label htmlFor="email">Email<span style={{color: 'red'}}>*</span></label>
                        <input id='email' defaultValue={accountData?.email} onChange={(e) => {setEmail(e.target.value); e.target.classList.remove(styles.empty_field);}}/>

                        <label htmlFor="tel">Phone Number</label>
                        <input type="tel" id='tel' autoComplete="tel-national" defaultValue={accountData?.phone_number}
                            onChange={(e) => {setPhoneNumber(e.target.value); e.target.classList.remove(styles.empty_field);}} 
                            onKeyDown={(e) => phoneKeydownListener(e)} 
                            onKeyUp={(e) => phoneKeyUpListener(e)} placeholder='(123) 456-7890'/>

                        <label htmlFor="category">Category<span style={{color: 'red'}}>*</span></label>
                        <select id='category' defaultValue={initialCategory} onChange={(e) => {setCategory(e.target.value); e.target.classList.remove(styles.empty_field);}}>
                            <option disabled hidden value={''}>-- Select Category --</option>
                            <option value='account-management'>Account Management</option>
                            <option value='account-permissions'>Account Permissions</option>
                            <option value='404-error'>404 Error</option>
                            <option value='issue-report'>Issue Report</option>
                            <option value='feature-request'>Feature Request</option>
                            <option value='funny-joke'>Funny Joke</option>
                        </select>

                        <label htmlFor='message'>Message<span style={{color: 'red'}}>*</span></label>
                        <textarea id='message' defaultValue={initialMessage} rows={8} onChange={(e) => {setMessage(e.target.value); e.target.classList.remove(styles.empty_field);}}/>
                        <div id={styles.bottom}>
                            <button id={styles.submit_btn} onClick={() => handleSubmit()}>Submit</button>
                            <p id={styles.submitted}>Form Submitted</p>
                        </div>
                    </div>
            </div>            
        </div>
    )
}

export default ContactPage;